import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Typography from '../../../components/common/Typography';
import Button from '../../../components/common/Button';
import FileInput from '../../../components/common/FileInput';

import previousAdd1 from '../../../asset/img/previous_add_1.svg';
import previousAdd2 from '../../../asset/img/previous_add_2.svg';
import { magamCertifyCheck } from '../../../common/Util';

const FileUploadStep = ({ onFileSelect, typeLabel, htmJType }) => {
  const { t } = useTranslation('previousEmployment');
  const fileRef = useRef(null);
  const { isMagam, isCertify } = useSelector(state => state.common);
  const handleFileChange = files => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    if (files && files.length > 0) {
      // 여러 파일 선택 시 모든 파일 전달
      onFileSelect(Array.from(files));
    }
  };

  const uploadImg = htmJType === '1' ? previousAdd1 : previousAdd2;

  return (
    <div className="displayFlexColumn" style={{ gap: '24px' }}>
      <Typography variant="subtitleBold" style={{ whiteSpace: 'pre-line' }}>
        {t('uploadSection.title', { type: typeLabel })}
      </Typography>
      <div
        className="displayFlex"
        style={{
          justifyContent: 'center',
          alignItems: 'center',
          background: 'var(--GrayScale-100)',
          borderRadius: '16px',
        }}>
        <img src={uploadImg} alt="upload" style={{ height: '90px' }} />
      </div>
      <Typography variant="body2Medium" style={{ color: 'var(--GrayScale-600)' }}>
        {htmJType === '1' ? t('uploadSection.description') : t('uploadSection.description2')}
      </Typography>
      <Button
        color="primary"
        onClick={() => fileRef.current.click()}
        value={t('uploadSection.uploadButton')}
      />
      <FileInput
        fileRef={fileRef}
        fileHandler={e => handleFileChange(e.target.files)}
        accept=".pdf,.jpg,.gif,.png,.jpeg"
        multiple
      />
    </div>
  );
};

export default FileUploadStep;
